import React from "react";
import "./howWeSupport.scss";
import contentSvg from "./content.svg";
import messageSvg from "./message.svg";
import healthSvg from "./health.svg";
import smallGroupSvg from "./smallGroup.svg";
import qaSvg from "./qa.svg";
import workshopSvg from "./workshop.svg";
import { Carousel } from "react-bootstrap";

const HowWeSupport = () => (
  <div className="preLoginHowWeSupport">
    <h3 className="heading3">
      How we <span>support you...</span>
    </h3>

    <div className="preLoginHowWeSupportList">
      {howWeSupportList.map((card) => (
        <div className="preLoginHowWeSupportCard" key={card.id}>
          <div className="preLoginHowWeSupportListGrow">
            <img src={card.icon} alt={card.title} />
          </div>
          <p className="title">{card.title}</p>
          <p className="description">{card.description}</p>
        </div>
      ))}
    </div>
    
    <Carousel className="preLoginHowWeSupportCarousel">
      {howWeSupportList.map((card) => (
        <Carousel.Item key={card.id}>
          <div className="preLoginHowWeSupportCard">
            <div className="preLoginHowWeSupportListGrow">
              <img src={card.icon} alt={card.title} />
            </div>
            <p className="title">{card.title}</p>
            <p className="description">{card.description}</p>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  </div>
);

const howWeSupportList = [
  {
    id: 0,
    icon: contentSvg,
    description:
      "Tap play and get clarity in the moment you need it most, even at 2am.",
    title: "On Demand Content",
  },
  {
    id: 1,
    icon: messageSvg,
    description:
      "Peace of mind knowing expert advice is just a message away, anytime.",
    title: "Message Board",
  },
  {
    id: 2,
    icon: healthSvg,
    description:
      "Your personal nurse, without the wait or the judgment.",
    title: "1:1 Telehealth Appointments",
  },
  {
    id: 3,
    icon: smallGroupSvg,
    description:
      "A community that gets it—because they're living it too.",
    title: "Peer Support",
  },
  {
    id: 4,
    icon: qaSvg,
    description:
      "Weekly check-ins to ease your worries and celebrate your wins.",
    title: "Virtual Q&As",
  },
  {
    id: 5,
    icon: workshopSvg,
    description:
      "Get expert answers without the overwhelm.",
    title: "Prenatal and Parenting Workshops",
  },
];

export default HowWeSupport;
